import { Alert, Divider, Skeleton } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import gql from 'graphql-tag';
import { useAuthedQuery } from 'utils/qlAuth';

export const RunwaymlFramesAutomation = (props: { qStory: any; storyId: number }) => {
  const qFrames = useAuthedQuery(
    gql`
      query FrameController_getRunwaymlFramesAutomation($storyId: Int!) {
        FrameController_getRunwaymlFramesAutomation(storyId: $storyId)
        FrameController_getRunwaymlFramesAutomation_Robot(storyId: $storyId)
      }
    `,
    {
      variables: { storyId: Number(props.storyId) },
    },
  );

  if (qFrames.error) {
    return <div>error</div>;
  }
  if (qFrames.loading) {
    return <Skeleton active />;
  }
  const robotString = qFrames.data?.FrameController_getRunwaymlFramesAutomation_Robot;
  return (
    <>
      <Alert
        message="RunwayML Image generation automation"
        description="Script for UI.Vision extension to automate images creation with RunwayML. Copy this script to UI.Vision and run it to create images."
        type="info"
        showIcon
        style={{ marginBottom: '16px' }}
      />
      <TextArea rows={30} value={robotString} />
    </>
  );
};
